import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { DeliveryZoneModel, HxDeliveryZoneService } from 'hx-services';
import { DeliveryZoneListComponent } from '@adm-web-app/modules/delivery-zones/list/list.component';
import { DeliveryZoneEditComponent } from '@adm-web-app/modules/delivery-zones/edit/edit.component';

const deliveryZoneResolveFn: ResolveFn<DeliveryZoneModel> = route => inject(HxDeliveryZoneService)
  .getZoneById(Number(route.paramMap.get('zoneId')));

export const deliveryZonesRoutes: Routes = [
  {
    path: '', component: DeliveryZoneListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: DeliveryZoneEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':zoneId/edit', component: DeliveryZoneEditComponent,
    resolve: {
      model: deliveryZoneResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
